.root {
  animation: pulse 1.5s ease-in-out infinite;
  background: var(--color-border);
  border-radius: 4px;
  height: 14px;
}

.circular {
  border-radius: 50%;
}

.rectangular {
  border-radius: 8px;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }
}
